import axios from "axios";

export default axios.create({
    baseURL: process.env.API_URL,
    crossdomain: true,
    withCredentials: false,
    headers: {
        "Content-Type": "application/json",
    }
});
